export const environment = {
  production: false,
  //urlApi: 'https://api-ard-stg.studiovatore.com/api/',

  urlApi: 'https://api-ard-prd.studiovatore.com/api/',
  recaptcha: {
    siteKey: '6Lczgp8qAAAAAF51AesevuPClRhxhVQwpZRoxz3B',
  },
  googleMaps: {
    apiKey: 'AIzaSyCuYCww_JRQWxkJsJqRdJx7YgoIWIT-JWY',
    version: 'weekly',
  },
};
